import { FormControl, MenuItem, Select } from "@mui/material";
import { IRatingProps } from "../types/interfaces/IRatingProps";

//This component is responsible for rendering the rating dropdown for competencies. 
const Rating: React.FC<IRatingProps> = ({ competency, isParent, onRatingChange, onDropdownClick }) => {
    let maxLevel: number = 9;
    if (isParent) maxLevel = 11;
    const levels =Array.from({length: maxLevel}, (_, i) => (i + 2) / 2).map((l) => l.toString());

    //Function to handle the rating change.
    const handleRatingChange = (key: string, rating: string | null) => {
        onRatingChange(key, rating);
    }

    //Function to handle the rating dropdown click.
    const handleDropdownClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        onDropdownClick(event);
    };

    return (
        <FormControl sx={{ display: 'flex', alignItems: 'left' }}>
            <Select
                id="selectRatingChange"
                disabled={competency.IsReadOnly}
                value={competency.Rating === null ? '' : competency.Rating}
                displayEmpty
                onChange={(e) => handleRatingChange(competency.CompetencyKey, e.target.value)}
                onClick={handleDropdownClick}
                sx={{ maxHeight: 20, marginRight: 2 }}>
                <MenuItem value=""><em>Select Level</em>
                </MenuItem>
                {levels.map((level) => (<MenuItem key={level} value={level}>{level}</MenuItem>))}
            </Select>
        </FormControl>
    );
}

export default Rating;